/* ===========================
IMPORTS
=========================== */
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// IMPORT - COMPONENTS
import ModalMaintenanceSchedule from './ModalMaintenanceSchedule';
import ModalTags from './ModalTags';
import BundleTable from './BundleTable';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
import Modal from '../Elements/Modal';
import ButtonSwitch from '../Elements/ButtonSwitch';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class CanvasDetails extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   */
  constructor(props) {
    super(props);
    this.state = {
      id: (this.props.id || null),
      data: {},
      modals: {
        schedule: false,
        tags: false,
      },
      modalData: null,
      modalSubmitted: false,
      loadingModal: false,
      loading: true,
    };

    this.handleShowModal = this.handleShowModal.bind(this);
    this.updateLoadingModal = this.updateLoadingModal.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.setModalSubmitted = this.setModalSubmitted.bind(this);
    this.get = this.get.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  get() {
    this.setState({
      loading: true,
    }, () => {
      this.request(
        (response) => {
          if (response.player) {
            this.setState({
              loading: false,
              data: response.player,
            });
          }
        },
      );
    });
  }

  /**
   * Main API request
   */
  request(callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players/${this.props.id}`,
      'GET',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {string} type
   * @param {boolean} show
   */
  handleShowModal(type, show) {
    const { modals } = this.state;
    modals[type] = show;
    this.setState({
      modals,
    });
  }

  /**
   * @param {boolean} show
   */
  updateLoadingModal(show) {
    this.setState({
      loadingModal: show,
    });
  }

  /**
   * @param {Event} event
   */
  handleEdit() {
    this.setState((prevState) => {
      const modalData = {
        id: prevState.id,
        recurrence: (prevState.data.maintenance_schedule.recurrence)
          ? prevState.data.maintenance_schedule.recurrence
          : null,
        start_date: (prevState.data.maintenance_schedule.start_date)
          ? prevState.data.maintenance_schedule.start_date
          : null,
        start_time: (prevState.data.maintenance_schedule.start_time)
          ? prevState.data.maintenance_schedule.start_time
          : null,
        end_time: (prevState.data.maintenance_schedule.end_time)
          ? prevState.data.maintenance_schedule.end_time
          : null,
        recurrence_param: (prevState.data.maintenance_schedule.recurrence_param
          && prevState.data.maintenance_schedule.recurrence_param.length > 0)
          ? prevState.data.maintenance_schedule.recurrence_param
          : [],
      };

      const { modals } = prevState;
      modals.schedule = true;

      return {
        modalData,
        modals,
      };
    });
  }

  /**
   * @param {boolean} submitted
   */
  setModalSubmitted(submitted) {
    this.setState({
      modalSubmitted: submitted,
    });
  }

  // eslint-disable-next-line consistent-return
  getMaintenanceScheduleText() {
    if (Object.keys(this.state.data.maintenance_schedule).length === 0) {
      return 'Not Set';
    }

    if (this.state.data.maintenance_schedule.recurrence === 'immediate') {
      return 'Immediate';
    }

    if (this.state.data.maintenance_schedule.recurrence === 'daily') {
      return `Daily between ${this.state.data.maintenance_schedule.start_time} and ${this.state.data.maintenance_schedule.end_time}`;
    }

    if (this.state.data.maintenance_schedule.recurrence === 'weekly') {
      return `Weekly on ${this.state.data.maintenance_schedule.recurrence_param.join(', ')} between ${this.state.data.maintenance_schedule.start_time} and ${this.state.data.maintenance_schedule.end_time}`;
    }

    if (this.state.data.maintenance_schedule.recurrence === 'monthly') {
      return `Monthly on ${this.state.data.maintenance_schedule.recurrence_param} between ${this.state.data.maintenance_schedule.start_time} and ${this.state.data.maintenance_schedule.end_time}`;
    }
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(this.state.loading)
          ? (<Loader />)
          : (
            <div className="row">
              <div className="col col-6">
                <div className="section-header">
                  <h3>Overview</h3>
                </div>

                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td>{(this.state.data.name || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Device ID</th>
                      <td>{(this.state.data.device_id || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Group</th>
                      <td>{(this.state.data.group_name || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Tenant</th>
                      <td>{(this.state.data.tenant_name || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Domain</th>
                      <td>{(this.state.data.stack_host || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Timezone</th>
                      <td>{(this.state.data.timezone || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Called</th>
                      <td>{(this.state.data.called_at || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Added On</th>
                      <td>{(this.state.data.created_at || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Bundle Rule</th>
                      <td>{(this.state.data.bundle_rule_name || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Bundle</th>
                      <td>
                        {(this.state.data.bundle
                          && this.state.data.bundle.name
                          && this.state.data.bundle.id)
                          ? (
                            <div>
                              <Link to={`/dashboard/bundles/${this.state.data.bundle.id}`} className="btn btn-info btn-sm">
                                <i className="fa fa-external-link" />
                                {this.state.data.bundle.name}
                              </Link>
                            </div>
                          )
                          : 'None'}
                      </td>
                    </tr>
                    <tr>
                      <th>First Activation Date</th>
                      <td>{(this.state.data.activation_date || 'None')}</td>
                    </tr>
                    <tr>
                      <th>Maintenance Window</th>
                      <td>
                        <button type="button" className="btn btn-primary btn-sm" onClick={this.handleEdit}>
                          <i className="fa fa-edit" />
&nbsp;
                          {this.getMaintenanceScheduleText()}
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th>Maintenance Override</th>
                      <td>
                        <ButtonSwitch
                          url={`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players/${this.props.id}`}
                          method="put"
                          status={this.state.data.maintenance_schedule_override}
                          callback={(response) => {
                            if (response.player && typeof (response.player.maintenance_schedule_override) === 'boolean') {
                              const maintenance = response.player.maintenance_schedule_override;
                              const { data } = this.state;
                              data.maintenance_schedule_override = maintenance;
                              this.setState({
                                data,
                              });
                            }
                          }}
                          on={{
                            player: {
                              maintenance_schedule_override: true,
                            },
                          }}
                          off={{
                            player: {
                              maintenance_schedule_override: false,
                            },
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Tags</th>
                      <td>
                        <button type="button" className="btn btn-rounded btn-primary btn-sm" onClick={() => { this.setState((prevState) => ({ modalData: prevState.data }), () => { this.handleShowModal('tags', true); }); }}>
                          <i className="fa fa-edit" />
&nbsp;Edit
                        </button>
&nbsp;
                        {(this.state.data.tags && this.state.data.tags.length > 0)
                          ? (
                            <div className="tags">
                              {(this.state.data.tags.map((item) => (
                                <div key={`tag-${item.name}`} className="tag btn-group btn-group-sm">
                                  <button type="button" className="btn btn-rounded btn-info">
                                    <i className="fa fa-tag" />
&nbsp;
                                    {item.name}
                                  </button>
                                </div>
                              )))}
                            </div>
                          )
                          : 'None'}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h3>Manufacturing</h3>
                <table className="table table-bordered">
                  <tbody>
                    {(Object.keys(this.state.data.manufacturing)
                      .map((item) => (
                        <tr key={item}>
                          <th>{item}</th>
                          <td>{this.state.data.manufacturing[item]}</td>
                        </tr>
                      )))}
                  </tbody>
                </table>
              </div>
              <div className="col col-6">
                <h3>Current Versions</h3>

                <div className="table-responsive">
                  <table className="table table-bordered">
                    <tr>
                      <th>Firmware</th>
                    </tr>
                    <tr>
                      <td>
                        {(this.state.data.firmware
                          && Object.keys(this.state.data.firmware).length > 0)
                          ? (
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Version</th>
                                    <th>Listed</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <td>{(this.state.data.firmware.version || 'None')}</td>
                                  <td>{(this.state.data.firmware.unlisted ? 'no' : 'yes')}</td>
                                </tbody>
                              </table>
                            </div>
                          )
                          : 'No Firmware Details'}
                      </td>
                    </tr>
                    <tr>
                      <th>APKS</th>
                    </tr>
                    <tr>
                      <td>
                        {(this.state.data.apks && this.state.data.apks.length > 0)
                          ? (
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Version</th>
                                    <th>Package</th>
                                    <th>Listed</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.data.apks.map((item) => (
                                    <tr key={`apk-${item.package_name}`}>
                                      <td>{item.version}</td>
                                      <td>{item.package_name}</td>
                                      <td>{item.unlisted ? 'no' : 'yes'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )
                          : 'No Apk Details'}
                      </td>
                    </tr>
                  </table>
                </div>

                <h3>Expected Versions</h3>
                {(this.state.data.bundle && this.state.data.bundle.id)
                  ? (<BundleTable id={this.state.data.bundle.id} />)
                  : 'No Bundle Details'}
              </div>
            </div>
          )}

        {(this.state.modals.schedule)
          ? (
            <Modal
              title="Maintenance Schedule"
              loading={this.state.loadingModal}
              updateLoadingModal={this.updateLoadingModal}
              submitted={this.state.modalSubmitted}
              cancel={(event) => {
                this.handleShowModal('schedule', false);
                event.preventDefault();
              }}
              buttonCloseLabel="Close"
              buttonCloseAction={(event) => {
                this.handleShowModal('schedule', false);
                event.preventDefault();
              }}
              buttonSubmitLabel="Update"
              buttonSubmitStyle="btn-success"
              buttonSubmitAction={(event) => {
                const form = document.getElementById('modal-view-schedule');
                form.getElementsByTagName('button')[0].click();
                event.preventDefault();
              }}
            >
              <ModalMaintenanceSchedule
                id="modal-view-schedule"
                data={this.state.modalData}
                updateLoadingModal={this.updateLoadingModal}
                submitted={this.state.modalSubmitted}
                handleSubmit={this.setModalSubmitted}
                handleSubmitSuccess={() => {
                  this.get();
                  this.handleShowModal('schedule', false);
                }}
              />
            </Modal>
          )
          : ''}

        {(this.state.modals.tags)
          ? (
            <Modal
              title="Tags"
              loading={this.state.loadingModal}
              updateLoadingModal={this.updateLoadingModal}
              submitted={this.state.modalSubmitted}
              cancel={(event) => {
                this.handleShowModal('tags', false);
                event.preventDefault();
              }}
              buttonCloseLabel="Close"
              buttonCloseAction={(event) => {
                this.handleShowModal('tags', false);
                event.preventDefault();
              }}
              buttonSubmitLabel="Update"
              buttonSubmitStyle="btn-success"
              buttonSubmitAction={(event) => {
                const form = document.getElementById('modal-view-tags');
                form.getElementsByTagName('button')[0].click();
                event.preventDefault();
              }}
            >
              <ModalTags
                id="modal-view-tags"
                loading={this.state.loadingModal}
                data={this.state.modalData}
                updateLoadingModal={this.updateLoadingModal}
                submitted={this.state.modalSubmitted}
                handleSubmit={this.setModalSubmitted}
                handleSubmitSuccess={() => {
                  this.get();
                }}
              />
            </Modal>
          )
          : ''}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
CanvasDetails.propTypes = {
  id: PropTypes.number,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(CanvasDetails);
